function normalizeAuthContext(input) {
    if (Array.isArray(input)) {
        return {
            attributes: input,
            permissions: [],
            role: null,
            currentLocation: null,
            locations: [],
        };
    }

    return {
        attributes: input?.attributes || input?.userDetails || input?.UserAttributes || [],
        permissions: Array.isArray(input?.permissions || input?.Permissions) ? (input.permissions || input.Permissions) : [],
        role: input?.role || input?.Role || null,
        currentLocation: input?.currentLocation || input?.CurrentLocation || null,
        locations: Array.isArray(input?.locations || input?.Locations) ? (input.locations || input.Locations) : [],
    };
}

function readAttribute(attributes, name) {
    if (!Array.isArray(attributes)) {
        return null;
    }

    const attribute = attributes.find((item) => item.Name === name);
    return attribute ? attribute.Value : null;
}

export function getUserRole(input) {
    const auth = normalizeAuthContext(input);
    return auth.role?.rolename || readAttribute(auth.attributes, 'custom:role');
}

export function getTenantId(input) {
    const auth = normalizeAuthContext(input);
    return readAttribute(auth.attributes, 'custom:tenantid');
}

export function isSuperAdmin(input) {
    const role = String(getUserRole(input) || '').toLowerCase();
    const tenantId = getTenantId(input);
    return role === 'superadmin' && !tenantId;
}

export function getUserEmail(input) {
    const auth = normalizeAuthContext(input);
    return readAttribute(auth.attributes, 'email');
}

export function getPermissions(input) {
    const auth = normalizeAuthContext(input);
    return auth.permissions;
}

export function getCurrentLocation(input) {
    const auth = normalizeAuthContext(input);
    return auth.currentLocation;
}

export function hasPermission(input, permission) {
    if (!permission) {
        return true;
    }

    const permissions = getPermissions(input);
    return permissions.includes('*') || permissions.includes(permission);
}

export function hasAnyPermission(input, permissions = []) {
    if (!permissions.length) {
        return true;
    }

    return permissions.some((permission) => hasPermission(input, permission));
}

export function hasRouteAccess(input, routeMeta = {}) {
    if (!routeMeta.requiresAuth) {
        return true;
    }

    const auth = normalizeAuthContext(input);
    if (!Array.isArray(auth.attributes) || !auth.attributes.length) {
        return false;
    }

    if (routeMeta.permission) {
        return hasPermission(auth, routeMeta.permission);
    }

    if (Array.isArray(routeMeta.permissionsAny) && routeMeta.permissionsAny.length > 0) {
        return hasAnyPermission(auth, routeMeta.permissionsAny);
    }

    if (Array.isArray(routeMeta.allowedRoles) && routeMeta.allowedRoles.length > 0) {
        return routeMeta.allowedRoles.includes(getUserRole(auth));
    }

    if (routeMeta.requiresSuperAdmin) {
        return isSuperAdmin(auth);
    }

    return true;
}
